module.exports = __webpack_public_path__ + "img/card3.5a1c16c5.svg";